import { getSessionClaims } from "../../sessionClaims";
// This module handles calls to third-party analytics libraries. For
// internal analytics, use the AnalyticsReporter module
// (go/kaggle-analytics-service).
import { registerPageview } from "./ThirdPartyServices/GoogleAnalytics";
export var googleAnalyticsRegisterPageview = function(track) {
    var claim = getSessionClaims();
    var ref;
    var params = track === "/" ? {
        // Previously there was the "2019" homepage variant.
        variant: "2023",
        // `claim.anon` is unset if user is logged in. See ClientSessionToken.cs
        anon: (ref = claim === null || claim === void 0 ? void 0 : claim.anon) !== null && ref !== void 0 ? ref : false
    } : undefined;
    registerPageview(track, params);
};
